import React from "react";
import { connect } from "react-redux";
import { Card, Col, Row, Button, Overlay, Popover } from 'react-bootstrap';
import PropTypes from "prop-types";
import { withNavigation } from "../../../utils/wrapper";
import Table from "../../../layout/table";

import Hamburger from "../../../layout/kebab";
import { search, batch } from "../../../actions/matter.party";
import { search as matters } from "../../../actions/matters";
import { get as getSettings } from "../../../actions/settings";


class Parties extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            size: 10,
            search: "",
            order: "caption",
            index: 0,
            direction: "DESC",
            data: [],
            pages: 0,
            loaded: false,
            menu: {}
        };
    }

    componentDidMount = async () => {
        await this.loadData();
    }

    normalizeRoleArray = (val) => {
        if (!val) return [];
        if (Array.isArray(val)) return val;

        if (typeof val === "string") {
            try {
                const parsed = JSON.parse(val);
                return Array.isArray(parsed) ? parsed : [];
            } catch {
                // fallback if someone stored "A,B,C"
                return val.split(",").map(s => s.trim()).filter(Boolean);
            }
        }

        return [];
    };

    toTag = (x) => {
        if (x == null) return null;
        if (typeof x === "string") return { value: x, label: x };
        // if already an object, try to coerce
        const v = x.value ?? x.label ?? String(x);
        const l = x.label ?? x.value ?? String(x);
        return { value: v, label: l };
    };

    data = () => {
        return this.state.data;
    }

    loadData = async () => {
        const rolesSetting = await this.props.getSettings({ authentic: true, name: "CASE_ROLES" });
        
        const __data = await this.props.search({
            page: this.state.page,
            size: this.state.size,
            order: this.state.order,
            direction: this.state.direction,
            assignment: "person",
            uuid: this.props.person,
            search: this.state.search
        });

        // suggestions list (typeahead list)
        const roleSuggestions =
            this.normalizeRoleArray(rolesSetting?.value).map(r => ({ value: r, label: r }));

        // ensure blank selector row at top
        const itemsRaw = __data?.items ?? [];

        // normalize selected roles for each row so ReactTags can render them
        const items = itemsRaw.map((row) => {
            const rawRoles = row.roles ?? row["Case_CaseParty.roles"]; // DB field likely here
            const rolesArr = this.normalizeRoleArray(rawRoles);

            return {
                ...row,
                roles: rolesArr.map(this.toTag).filter(Boolean)
            };
        });

        let __count = 0;
        if ((items?.length || 0) > 0) {
            __count = Math.ceil(Number(__data.count) / Number(this.state.size));
        }

        this.setState({
            data: items,
            roles: roleSuggestions,
            pages: __count,
            loaded: true
        });
    };


    onCaptionFormat = (e, row) => {
        return <>
            <Button variant="link" className="p-0 align-baseline" onClick={() => this.props.navigate(`/dashboard/matters/${row.uuid}`)}>{row.caption} {row.caseNumber}</Button>
                        
            {row.status &&
                <button
                    type="button"
                    className="badge rounded-pill bg-success"
                    style={{ marginLeft: 5 }}
                >
                    {row.status?.toUpperCase()}
                </button>
            }
            {row.style &&
                <button
                    type="button"
                    className="badge rounded-pill bg-success"
                    style={{ marginLeft: 5 }}
                >
                    {row.style?.toUpperCase()}
                </button>
            }
            
        </>
    }

    onCourtFormat = (e, row) => {
        return (
            <><Button variant="link" className="p-0 align-baseline" onClick={() => this.props.navigate(`/dashboard/matters/${row.uuid}`)}>{row["Court.full"]}</Button>
            </>)
    }

    onRolesFormat = (e, row) => {
        return (
            <>
                <Button variant="link" className="p-0 align-baseline" onClick={() => this.props.navigate(`/dashboard/matters/${row.uuid}`)}>{ (row["Case_CaseParty.attorney"]==1 ? "Attorney for " : "") + row["Case_CaseParty.roles"].join(", ") }</Button>
            </>)
    }

    openHamburger = (event, uuid) => {
        event.preventDefault();
        this.setState({
            menu: {
                show: true,
                uuid,
                target: event.currentTarget
            }
        });
    }

    closeHamburger = () => {
        this.setState(prev => ({
            menu: {
                ...prev.menu,
                show: false,
                target: null
            }
        }));
    }

    onActionFormat = (e, row) => {
        return (<>
            <Hamburger variant="link" vertical={false} onClick={(e) => this.openHamburger(e, row.uuid)} />
            </>)
    }

    onPageChange = (e) => {
        this.setState({
            page: Number(e)
        }, this.loadData);
    }

    onColumnClick = (e) => {
        const __array = this.headers;
        const __index = __array.findIndex((item) => {
            return item.header === e.header && item.source === e.source;
        });

        this.setState({
            index: __index,
            direction: this.state.index === __index && this.state.direction === "DESC" ? "ASC" : "DESC",
            order: __array[__index].source,
            page: 0
        }, this.loadData);
    }

    onSearch = (e) => {
        this.setState({
            search: e
        }, this.loadData);
    }

    onSize = (e) => {
        this.setState({
            page: 0,
            size: Number(e)
        }, this.loadData);
    }

    get headers() {
        return [
            {
                header: "Caption",
                sortable: true,
                source: "caption",
                className: "text-muted text-small text-uppercase w-35",
                onRender: this.onCaptionFormat
            },
            {
                header: "Court",
                sortable: false,
                source: "court",
                className: "text-muted text-small text-uppercase w-20",
                onRender: this.onCourtFormat
            },
            {
                header: "Roles",
                sortable: false,
                source: "uuid",
                className: "text-muted text-small text-uppercase w-40",
                onRender: this.onRolesFormat
            },
            {
                header: "",
                sortable: false,
                source: "uuid",
                onRender: this.onActionFormat
            }
        ]
    }



    render() {
        if (!this.state.loaded && this.state.data.length < 1) {
            return null;
        }

        if (this.state.loaded && this.state.data.length < 1 && !String(this.state.search || "").trim()) {
            return null;
        }

        return (
            <Card body className="mb-5">
                <Row className="g-3">
                    <Col xs="12">
                        <h2 className="small-title">Matters</h2>
                    </Col>
                    <Col xs="12">
                        <Table
                            headers={this.headers}
                            page={this.state.data}
                            sort={{ index: this.state.index, direction: this.state.direction }}
                            size={this.state.size}
                            index={this.state.page}
                            pages={this.state.pages}
                            onColumnClick={this.onColumnClick}
                            onPageChange={this.onPageChange}
                            onSearch={this.onSearch}
                            onSize={this.onSize}
                            searchable
                            sizable
                        />
                    </Col>
                </Row>
                <Overlay
                    target={this.state.menu.target}
                    show={this.state.menu.show}
                    placement="bottom-end"
                    rootClose
                    onHide={this.closeHamburger}
                >
                    {(props) => (
                        <Popover {...props}>
                           
                            <Popover.Body>
                                <Row className="mb-2">
                                    <Col className="d-flex flex-row mt-1">
                               
                                        <button
                                            type="button"
                                            className="btn btn-link p-0 me-2 btn-sm small text-start"
                                            onClick={() => this.props.navigate(`/dashboard/matters/${this.state.menu.uuid}`)}
                                        >
                                            Open
                                                </button></Col></Row><Row>
                                            <Col className="d-flex flex-row mt-1">
                                        <button
                                            type="button"
                                            className="btn btn-link p-0 me-2 btn-sm small text-start"
                                            onClick={() => this.promptDelete(this.state.menu.uuid)}
                                        >
                                            Delete
                                        </button></Col>
                                    </Row>
                            </Popover.Body>
                        </Popover>
                    )}
                </Overlay>
            </Card>
        )
    }
}

Parties.propTypes = {
    auth: PropTypes.object.isRequired
}

const mapStateToProps = (state) => {
    return ({
        auth: state.auth
    })
}


export default withNavigation(
    connect(
        mapStateToProps,
        {
            search,
            batch,
            matters,
            getSettings
        },
        null,
        { forwardRef: true }
    )(Parties));
